import $ from 'jquery';

$.extendPrototype = function (Base) {
  const prototypes = Array.from(arguments);
  prototypes.shift();
  $.extend(...[true, Base.prototype].concat(prototypes));
  Base.prototype.constructor = Base;
};
